module.exports = __webpack_public_path__ + "static/media/sell_interview_8.be9de6e0.jpg";